import { Check } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { PROGRAMS } from "../../data";

export const Programs = () => (
  <section
    id="programs"
    data-testid="programs-section"
    className="relative border-t border-white/10 bg-[#050505] py-24 md:py-32"
  >
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="mb-16 max-w-3xl">
        <Reveal>
          <SectionLabel>[ Programs & Services ]</SectionLabel>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-heading text-4xl font-black uppercase leading-none tracking-tight text-white md:text-6xl">
            Choose your track
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-xl font-body text-white/60 md:text-lg">
            Start with a diagnostic, commit to velocity, or build year-round. Every tier
            is built on the same data-first foundation.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        {PROGRAMS.map((p, i) => (
          <Reveal
            key={p.name}
            delay={i * 0.1}
            className={`relative flex flex-col p-8 transition-transform duration-300 hover:-translate-y-1 ${
              p.featured
                ? "border border-[#00F0FF] bg-[#00F0FF]/[0.04] shadow-[inset_0_1px_2px_rgba(0,240,255,0.15)]"
                : "border border-white/10 bg-white/[0.015]"
            }`}
            data-testid={`program-card-${i}`}
          >
            {p.featured && (
              <span className="absolute -top-3 left-8 bg-[#00F0FF] px-3 py-1 font-mono text-[10px] font-bold uppercase tracking-[0.15em] text-black">
                Most Popular
              </span>
            )}
            <h3 className="font-heading text-2xl font-bold uppercase tracking-tight text-white">
              {p.name}
            </h3>
            <p className="mt-1 font-body text-sm text-[#00F0FF]">{p.tagline}</p>

            <div className="mt-8 flex items-end gap-1">
              <span className="font-mono text-sm text-white/50">$</span>
              <span className="font-heading text-6xl font-black leading-none text-white">
                {p.price}
              </span>
              <span className="mb-1 font-mono text-sm text-white/50">{p.cadence}</span>
            </div>

            <div className="my-8 h-px w-full bg-white/10" />

            <ul className="flex-1 space-y-4">
              {p.features.map((feat) => (
                <li key={feat} className="flex items-start gap-3 font-body text-sm text-white/70">
                  <Check size={16} className="mt-0.5 shrink-0 text-[#00F0FF]" strokeWidth={2.5} />
                  {feat}
                </li>
              ))}
            </ul>

            <a
              href="#contact"
              data-testid={`program-cta-${i}`}
              className={`mt-10 inline-flex w-full items-center justify-center px-6 py-3.5 font-mono text-xs font-bold uppercase tracking-[0.12em] transition-transform duration-200 hover:scale-[1.03] ${
                p.featured
                  ? "bg-[#00F0FF] text-black"
                  : "border border-white/20 text-white hover:border-[#00F0FF] hover:text-[#00F0FF]"
              }`}
            >
              Learn More
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Programs;
